export enum PagingItem {
    NEWS_ITEM = 'newsItem',
}
